import cx from 'classnames';
import Styles from './index.module.scss';

export interface ICommonPageModal {
  className?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  okText?: string | React.ReactNode;
  exitText?: string | React.ReactNode;
  isShowCloseIcon?: boolean;
  buttonMultiple?: boolean;
  onCancel: () => void;
  onExit: () => void;
  onConfirm: () => void;
}

const CommonPageModal = ({
  title,
  onCancel,
  onExit,
  onConfirm,
  className = '',
  description = '保存已添加内容，后续继续编辑',
  okText = '保存并退出',
  exitText = '退出',
  isShowCloseIcon = true,
  buttonMultiple = true,
}: ICommonPageModal) => {
  const handleCancel = () => {
    onCancel();
  };

  const handleExit = () => {
    onExit();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className={cx(Styles.root, className)}>
      <div className={Styles.wrapper}>
        <div className={Styles.titleWrapper}>
          {isShowCloseIcon && <div className={Styles.cancel} onClick={handleCancel} />}
          {title && <div className={Styles.title}>{title}</div>}
          <div className={Styles.description}>{description}</div>
        </div>
        <div className={Styles.actions}>
          {
            buttonMultiple ? 
            <div className={Styles.actionWrapper}>
              <div className={cx(Styles.action, Styles.exit)} onClick={handleExit}>{exitText}</div>
              <div className={Styles.divider} />
              <div className={cx(Styles.action, Styles.confirm)} onClick={handleConfirm}>{okText}</div>
            </div> :
            <div className={cx(Styles.action, Styles.exit)} onClick={handleExit}>{exitText}</div>
          }
        </div>
      </div>
    </div>
  )
};

export default CommonPageModal;
